'use client';
import '@STYLE/styles/modal.css';
import { useState } from 'react';

import { useAskModalStore } from '@/store/store';

import sendMail from '@/store/nodemailer';

const initAskForm = {
  name: '',
  title: '',
  company: '',
  hp: '',
  email: '',
  text: '',
}

export default function Ask({ handleAskModal }) {
  const { isOpen, openModal, closeModal } = useAskModalStore();

  const [askForm, setAskForm] = useState(initAskForm);

  const submitMail = async () => {
    let mailData = {
      subject: askForm.title,
      html: `
        <strong>소속:</strong> ${askForm.company}<br>
        <strong>이름:</strong> ${askForm.name}<br>
        <strong>이메일:</strong> ${askForm.email}<br>
        <strong>연락처:</strong> ${askForm.hp}<br><br><br>

        ${askForm.text.toString().replace(/\n/g, '<br>')}
      `,
    }

    const result = await sendMail(mailData);
    if(result?.accepted?.length > 0) {
      alert('문의완료');
      closeModal();
      setAskForm(initAskForm);
    } else if(result?.rejected?.length > 0) {
      alert('전송에 실패했습니다.');
    }
  }


  return (
    <>
      <div className={`modal inquiry ${isOpen ? 'active' : ''}`}>
        <div className="mdContainer">
          <div className="mdWrap">
            <div className="mdHead">
              <h3 className="mdTitle">서비스 문의하기</h3>
              <a className="closeModal" onClick={() => closeModal()}>
                <img src="/img/icon/icon_close.svg" />
              </a>
            </div>
            <div className="mdBody">
              <div className="mdDescWrap">
                <p className="mdDesc">
                  아이원페이먼트는 노력하고 믿음을 바탕으로 함께하고 있습니다. 아래 양식을
                  작성해주시면 확인 후 빠르게 연락드리겠습니다.
                </p>
                {/* <p className="mdDesc">
                  문의메일 : <span lang="en">i-one@ionepayment.com</span>
                </p> */}
              </div>
              <div className="formWrap">
                <form id="inquiryForm">
                  <fieldset className="inquiryFld">
                    <legend>아이원페이먼트 서비스 문의 폼</legend>
                  </fieldset>
                  <div className="inputWrap">
                    <div className="inputRow">
                      <div className="input required">
                        <strong>담당자명/직책</strong>
                        {askForm.name.length == 0 && 
                          <label htmlFor="name">이름 및 직책을 입력하세요.</label>
                        }
                        <input
                          type="text"
                          id="name"
                          autoCapitalize="off"
                          spellCheck="false"
                          value={askForm.name}
                          onChange={(e) => setAskForm({...askForm, name: e.target.value})}
                          maxLength={20}
                        />
                        <div className="util">
                          <span className="inputDel" />
                        </div>
                      </div>
                    </div>
                    <div className="inputRow">
                      <div className="input">
                        <strong>회사명</strong>
                        {askForm.company.length == 0 &&
                          <label htmlFor="company">회사명을 입력하세요.</label>
                        }
                        <input
                          type="text"
                          id="company"
                          autoCapitalize="off"
                          spellCheck="false"
                          value={askForm.company}
                          onChange={(e) => setAskForm({...askForm, company: e.target.value})}
                          maxLength={30}
                        />
                        <div className="util">
                          <span className="inputDel" />
                        </div>
                      </div>
                    </div>
                    <div className="inputRow">
                      <div className="input required">
                        <strong>휴대폰 번호</strong>
                        {askForm.hp.length == 0 &&
                          <label htmlFor="phone">'-'를 빼고 입력해주세요.</label>
                        }
                        <input
                          type="tel"
                          id="phone"
                          autoCapitalize="off"
                          spellCheck="false"
                          value={askForm.hp}
                          onChange={(e) => setAskForm({...askForm, hp: e.target.value})}
                          maxLength={20}
                        />
                        <div className="util">
                          <span className="inputDel" />
                        </div>
                      </div>
                    </div>
                    <div className="inputRow">
                      <div className="input required">
                        <strong>이메일</strong>
                        {askForm.email.length == 0 && 
                          <label htmlFor="email">이메일 주소를 입력하세요.</label>
                        }
                        <input
                          type="text"
                          id="email"
                          autoCapitalize="off"
                          spellCheck="false"
                          value={askForm.email}
                          onChange={(e) => setAskForm({...askForm, email: e.target.value})}
                          maxLength={20}
                        />
                        <div className="util">
                          <span className="inputDel" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="inputWrap">
                    <div className="inputRow">
                      <div className="input required">
                        <strong>제목</strong>
                        {askForm.title.length == 0 &&
                          <label htmlFor="title">원하시는 서비스명을 입력하세요.</label>
                        }
                        <input
                          className="count"
                          type="text"
                          id="title"
                          autoCapitalize="off"
                          spellCheck="false"
                          value={askForm.title}
                          onChange={(e) => setAskForm({...askForm, title: e.target.value})}
                          maxLength={30}
                        />
                        <div className="util">
                          <span className="inputDel" />
                          <span className="count" lang="en">
                            {askForm.title.length}/30
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="inputRow">
                      <div className="input required">
                        <strong>내용</strong>
                        {askForm.text.length == 0 &&
                          <label htmlFor="comment">문의하실 내용을 입력하세요.</label>
                        }
                        <textarea
                          className="count"
                          id="comment"
                          autoCapitalize="off"
                          spellCheck="false"
                          value={askForm.text}
                          onChange={(e) => setAskForm({...askForm, text: e.target.value})}
                          maxLength={500}
                        />
                        <div className="util">
                          <span className="count" lang="en">
                            {askForm.text.length}/500
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="btnWrap">
                    <button className="btn btnCancel" type="button" onClick={() => closeModal()}>
                      취소
                    </button>
                    <button className="btn btnPrimary" type="button" id="sendSubmit" onClick={() => submitMail()}>
                      제출
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="overlay" />
      </div>

    </>
  )
}